import { render, staticRenderFns } from "./AddTournament.vue?vue&type=template&id=0ced4611"
import script from "./AddTournament.vue?vue&type=script&lang=js"
export * from "./AddTournament.vue?vue&type=script&lang=js"
import style0 from "./AddTournament.vue?vue&type=style&index=0&id=0ced4611&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports